import React from 'react'
import image1 from '../Assets/collage1999.jpg';
import image2 from '../Assets/overlay.png';
import './SecOverlay.css'

function SecOverlay() {
  return (
    <div>
      <header>
        <div className="container secoverlay">
        </div>
      </header>
      <section className="cool-effect">
     <div>
      <img className='overly' src={image2} alt='' style={{display: "none"}}/>
     </div>
        <img className='bgblur' src={image1} style={{width: "100%", height: "1100px"}} />
      </section>
    </div>
  )
}
export default SecOverlay